//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalenderContext",
  components: {
    ScheduleCalenderItem: () => import("@/components/common/ScheduleCalendar/ScheduleCalenderItem"),
    ScheduleCalendarSort: () => import("@/components/common/ScheduleCalendar/ScheduleCalenderSort"),
  },
  computed: {
    ...mapGetters({
      id: 'schedule-calendar/id',
      entity: 'schedule-calendar/entity',
      smRegistered: 'schedule-calendar/smRegistered',
      current: 'schedule-calendar/currentDay',
      agency: 'schedule-calendar/agency',
      title: 'schedule-calendar/title',
      sortType: 'schedule-calendar/sortType',
      context: 'schedule-calendar/context',
    }),
    sortedContext() {
      if (this.context?.length > 0) {
        return this.context.map(item => item)
          .sort(this[this.sortType])
      }
      return []
    }
  },
  methods: {
    'by-time-asc'(a, b) {
      if (a.time > b.time) {
        return 1;
      }
      if (a.time < b.time) {
        return -1;
      }
      return 0;
    },
    'by-time-desc'(a, b) {
      if (a.time < b.time) {
        return 1;
      }
      if (a.time > b.time) {
        return -1;
      }
      return 0;
    },
    'by-title-asc'(a, b) {
      if (a.title > b.title) {
        return 1;
      }
      if (a.title < b.title) {
        return -1;
      }
      return 0;
    },
    'by-title-desc'(a, b) {
      if (a.title < b.title) {
        return 1;
      }
      if (a.title > b.title) {
        return -1;
      }
      return 0;
    },
    'by-remain-asc'(a, b) {
      if (Number(a.items_remain) > Number(b.items_remain)) {
        return 1;
      }
      if (Number(a.items_remain) < Number(b.items_remain)) {
        return -1;
      }
      return 0;
    },
    'by-remain-desc'(a, b) {
      if (Number(a.items_remain) < Number(b.items_remain)) {
        return 1;
      }
      if (Number(a.items_remain) > Number(b.items_remain)) {
        return -1;
      }
      return 0;
    },
    'by-price-asc'(a, b) {
      if (Number(a.price.replace('.', '')) > Number(b.price.replace('.', ''))) {
        return 1;
      }
      if (Number(a.price.replace('.', '')) < Number(b.price.replace('.', ''))) {
        return -1;
      }
      return 0;
    },
    'by-price-desc'(a, b) {
      if (Number(a.price.replace('.', '')) < Number(b.price.replace('.', ''))) {
        return 1;
      }
      if (Number(a.price.replace('.', '')) > Number(b.price.replace('.', ''))) {
        return -1;
      }
      return 0;
    },
  }
}
